export default "__VITE_ASSET__CJHahWIH__"